import api from './api';

export async function fetchLists(type) {
    const params = type ? { type } : {};
    const r = await api.get('/lists', { params });
    return r.data.lists || [];
}

export async function fetchList(id) {
    const r = await api.get(`/lists/${id}`);
    return r.data.list;
}

export async function createList(payload) {
    const r = await api.post('/lists', payload);
    return r.data.list;
}

export async function updateList(id, payload) {
    const r = await api.patch(`/lists/${id}`, payload);
    return r.data.list;
}

export async function deleteList(id) {
    await api.delete(`/lists/${id}`);
}

export async function addItem(listId, text) {
    const r = await api.post(`/lists/${listId}/items`, { text });
    return r.data.list;
}

export async function patchItem(listId, itemId, payload) {
    const r = await api.patch(`/lists/${listId}/items/${itemId}`, payload);
    return r.data.list;
}

export async function deleteItem(listId, itemId) {
    const r = await api.delete(`/lists/${listId}/items/${itemId}`);
    return r.data.list;
}

export async function addContact(listId, payload) {
    const r = await api.post(`/lists/${listId}/contacts`, payload);
    return r.data.list;
}

export async function patchContact(listId, contactId, payload) {
    const r = await api.patch(`/lists/${listId}/contacts/${contactId}`, payload);
    return r.data.list;
}

export async function deleteContact(listId, contactId) {
    const r = await api.delete(`/lists/${listId}/contacts/${contactId}`);
    return r.data.list;
}

export const LIST_TYPE_LABELS = {
    elementos: 'Lista de elementos',
    nota: 'Nota rápida',
    contactos: 'Lista de contactos',
};

export const EMOJI_SUGGESTIONS = [
    '📝', '🛒', '🏠', '🔐', '🚨', '🧺', '🎂', '🆘', '🔧', '💊', '📞', '🎁',
    '🍽️', '🧹', '✈️', '🚗', '💡', '🧾', '🎒', '📚', '🐾', '👶', '🎵', '🏥',
];
